interface FormDivisorProps {
  title: string;
}

export default function FormDivisor({ title }: FormDivisorProps) {
  return (
    <div className="flex flex-col grow mb-2">
      <p className="text-md text-blue-base font-bold">{title}</p>
      <hr className="border border-primary" />
    </div>
  );
}
